module.exports = __webpack_public_path__ + "static/media/ic_license_inactive.31aa4bf8.svg";